module.exports = __webpack_public_path__ + "img/ICCA.825267c6.png";